import { useState } from "react";
import { useTranslation } from "react-i18next";
import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import apiClient from "../../lib/common/apiClient";
import ConfirmDialog from "../dialogTypes/ConfirmDialog";

function TkDeliveryApplyButton ( props ) {

    const { t } = useTranslation();

    const { id, refresh, onSuccess, onFailure, onSelectMst, schema, customizeErrorMsgCallback, ...others } = props;

    const [ open, setOpen ] = useState(false);
    const [confirmMsg, setConfirmMsg] = useState();
    const [confirmData, setConfirmData] = useState();

    const onOpen = () => {

        setOpen ( true );

        setConfirmMsg ( t( "dialog.msg.confirm.Delivery", { deliveryNo: onSelectMst.shipmentNo } ) );
        setConfirmData({ ...onSelectMst , shipId : "ship"});

    };

    const onClose = () => {

        setOpen ( false );

    };

    const onCreateSuccess = ( msg ) => {

        if ( onSuccess ) {

            onSuccess ( msg );

        }

        refresh.refresh ();

    };

    const onOk = (data) => {
        
        let url = `/api/MomSysShipment/${onSelectMst.shipmentId}`;

        let form = new FormData();

        let deleted = {};

        form.append("deleted", JSON.stringify(deleted));
        form.append("json", JSON.stringify(data));

        apiClient.patch(url,  form, {})
        .then((result) => {
            onCreateSuccess ( result.data );
        
        })

        .catch ( ( reason ) => {

            onFailure ( t ( "error.updateFailure", { reason: reason.response ? reason.response.data : JSON.stringify ( reason ) } ) );

        });
    }

    return (

        <>
            <CreateRecordButtonLayout id={id+"apply-button"} onClick={onOpen} createButtonName ={"applyDelivery"} {...others} />
            <ConfirmDialog
                id={id+"-cancel-confirm-dialog"}
                title={ schema ? t ( `dialog.title.${schema.name}.apply` ) : "" }
                msg={confirmMsg}
                data={confirmData}
                open={open}
                onClose={onClose}
                onOk={onOk}
                onCancel={onClose}
            />
        </>

    );
}

export default TkDeliveryApplyButton;

